const STORAGE_KEY = "onedpdp_notification_sound";

let audioCtx = null;
let lastChimeAt = 0;
const CHIME_COOLDOWN_MS = 1200;

function readStoredPreference() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === "0" || raw === "off" || raw === "false") return false;
    if (raw === "1" || raw === "on" || raw === "true") return true;
  } catch {
    /* ignore */
  }
  return true;
}

export function isNotificationSoundEnabled() {
  return readStoredPreference();
}

export function persistNotificationSoundEnabled(enabled) {
  try {
    localStorage.setItem(STORAGE_KEY, enabled ? "1" : "0");
  } catch {
    /* ignore */
  }
}

function getAudioContext() {
  if (typeof window === "undefined") return null;
  const Ctor = window.AudioContext || window.webkitAudioContext;
  if (!Ctor) return null;
  if (!audioCtx || audioCtx.state === "closed") {
    audioCtx = new Ctor();
  }
  return audioCtx;
}

export function unlockNotificationAudio() {
  const ctx = getAudioContext();
  if (!ctx) return;
  if (ctx.state === "suspended") {
    ctx.resume().catch(() => {});
  }
}

function tone(ctx, { frequency, start, duration, peak = 0.18 }) {
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = "sine";
  osc.frequency.setValueAtTime(frequency, start);
  gain.gain.setValueAtTime(0.0001, start);
  gain.gain.exponentialRampToValueAtTime(peak, start + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, start + duration);
  osc.connect(gain);
  gain.connect(ctx.destination);
  osc.start(start);
  osc.stop(start + duration + 0.03);
}

/** One short ding per notification. Cooldown blocks duplicate plays of the same event. */
export function playNotificationChime({ force = false } = {}) {
  if (!force && !readStoredPreference()) return;
  const nowMs = Date.now();
  if (!force && nowMs - lastChimeAt < CHIME_COOLDOWN_MS) return;
  lastChimeAt = nowMs;
  try {
    const ctx = getAudioContext();
    if (!ctx) return;
    const start = () => {
      tone(ctx, { frequency: 784, start: ctx.currentTime, duration: 0.22, peak: 0.16 });
    };
    if (ctx.state === "suspended") {
      ctx.resume().then(start).catch(() => {});
      return;
    }
    start();
  } catch {
    /* ignore autoplay / unsupported audio */
  }
}
